import { render, staticRenderFns } from "./ShippingNotice.vue?vue&type=template&id=f5eae626&"
import script from "./ShippingNotice.vue?vue&type=script&lang=js&"
export * from "./ShippingNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JVolke\\Documents\\plentyDevTool\\38722\\18\\KrauseSohn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5eae626')) {
      api.createRecord('f5eae626', component.options)
    } else {
      api.reload('f5eae626', component.options)
    }
    module.hot.accept("./ShippingNotice.vue?vue&type=template&id=f5eae626&", function () {
      api.rerender('f5eae626', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/checkout/ShippingNotice.vue"
export default component.exports